import { makeStyles } from '@material-ui/core/styles';

import { dangerColor } from '../../lib/theme';

export const useReportCardAvailabilityStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginLeft: 'auto',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    margin: theme.spacing(1.5, 0),
  },
  revokedNotice: {
    borderLeft: `3px solid ${dangerColor}`,
    paddingLeft: theme.spacing(1.5),
    margin: theme.spacing(1, 0),
  },
  settingCaption: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginLeft: theme.spacing(6),
    marginTop: theme.spacing(-1),
  },
  section: {
    marginTop: theme.spacing(2),
  },
  skipped: {
    margin: theme.spacing(0.5, 0, 0),
    paddingLeft: theme.spacing(3),
  },
  inline: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
}));
